<ng-container [ngSwitch]="currentStep">
    <div class="stepper-header">
        <div class="stepper-header-title">
            <span>{{ sectionTitle }}</span>
        </div>
        <mat-progress-bar mode="determinate" [value]="progress" color="primary"></mat-progress-bar>
    </div>
    <lgv-owned-address-plan class="step-body" *ngSwitchCase="PropertySteps.OwnedAddressPlan"
        (stepChange)="goToStep($event)" (sectionChange)="goToSection($event)"></lgv-owned-address-plan>
    <lgv-previous-ownership class="step-body" *ngSwitchCase="PropertySteps.PreviousOwnership"
        (stepChange)="goToStep($event)" (sectionChange)="goToSection($event)"></lgv-previous-ownership>
    <lgv-property-usage class="step-body" *ngSwitchCase="PropertySteps.PropertyUsage" (stepChange)="goToStep($event)"
        (sectionChange)="goToSection($event)"></lgv-property-usage>
    <lgv-purchase-subject-address class="step-body" *ngSwitchCase="PropertySteps.PurchaseSubjectAddress"
        (stepChange)="goToStep($event)" (sectionChange)="goToSection($event)"></lgv-purchase-subject-address>
    <lgv-refinance-first-lien class="step-body" *ngSwitchCase="PropertySteps.RefinanceFirstLien"
        (stepChange)="goToStep($event)" (sectionChange)="goToSection($event)"></lgv-refinance-first-lien>
    <lgv-refinance-owned-address class="step-body" *ngSwitchCase="PropertySteps.RefinanceOwnedAddress"
        (stepChange)="goToStep($event)" (sectionChange)="goToSection($event)"></lgv-refinance-owned-address>
    <lgv-refinance-second-lien class="step-body" *ngSwitchCase="PropertySteps.RefinanceSecondLien"
        (stepChange)="goToStep($event)" (sectionChange)="goToSection($event)"></lgv-refinance-second-lien>
    <lgv-refinance-subject-address class="step-body" *ngSwitchCase="PropertySteps.RefinanceSubjectAddress"
        (stepChange)="goToStep($event)" (sectionChange)="goToSection($event)"></lgv-refinance-subject-address>
    <lgv-refinance-type class="step-body" *ngSwitchCase="PropertySteps.RefinanceType" (stepChange)="goToStep($event)"
        (sectionChange)="goToSection($event)"></lgv-refinance-type>
</ng-container>